<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modal-nciudad">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b> {{title}} </b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
              <div class="form-group" :class="{'has-error': validation.hasError('ciudad.nombre')}">
                <div class="input-group input-group-sm">
                  <div class="input-group-addon"> <span class="text-danger">*</span> Nombre</div>
                  <input type="text" v-model.trim="ciudad.nombre" class="form-control" placeholder="Solo letras">
                  <span class="input-group-addon">Nombre de la Ciudad</span>
                </div>
                <div class="error" v-if="validation.hasError('ciudad.nombre')"> {{validation.firstError('ciudad.nombre')}} </div>
              </div>
              
              
              <div class="form-group" :class="{'has-error': validation.hasError('ciudad.iddepartamento')}">
                <div class="input-group input-group-sm">
                    <div class="input-group-addon"> <span class="text-danger">* </span> Departamento: </div>
                  <Depas :model="ciudad"/>
                </div>
                <div class="error" v-if="validation.hasError('ciudad.iddepartamento')"> {{validation.firstError('ciudad.iddepartamento')}} </div>
              </div>
            </div>
            
            <Alertas ref="alertar" />
            <div class="modal-footer">
                <button @click="validarCampos" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
import Depas from '@/components/ADepartamentos.vue'
import gql from 'graphql-tag'
import { Validator } from 'simple-vue-validator'
    export default {
      props:{edit:{type:Object,required:false}},
        data(){
            return{
              ciudad:{nombre:null,iddepartamento:null,},
              activo: true,
              title:'',
            }
        },
        watch:{},
        components:{Alertas,Depas},
        validators: {
          'ciudad.nombre'(value){ return Validator.value(value).required(); },
          'ciudad.iddepartamento'(value){ return Validator.value(value).required(); },
        },
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
                window.console.log( 'closeddd' );
            },
            llenar(){
              this.title = 'Registrar Nueva Ciudad';
                if( !this.edit.id ) return;
                this.title = 'Editar Ciudad';
                this.ciudad.nombre=this.edit.nombre;
                this.ciudad.iddepartamento=this.edit.departamento;
            },
             validarCampos(){
              this.$validate().then((success) => {
                var obj = window.Object.assign( {},this.ciudad );
                  if (success) {
                    this.submit();
                  }else{
                    window.console.log( "HHHHH",window.stringifyObject(obj) );
                    this.$refs.alertar.invalido();
                  }
              });
            },
            submit(){
              if( this.edit.id ){
                    this.actualizar();
                    return;
                }
                var vue = this;
                vue.$refs.alertar.cargando('Registrando...');
                vue.activo = false;
                const obj = window.Object.assign({},this.ciudad);
                obj.iddepartamento = obj.iddepartamento.id;
                var sql = gql`mutation{ createCiudad(input:${window.stringifyObject(obj)}){ok,errors{message}}}`;

                this.$apollo.mutate({
                    mutation: sql,
                }).then((data) => {
                    let d = data.data.createCiudad;
                    window.console.log('DATA:',data);
                    if( d.ok ){
                        vue.$refs.alertar.success('Registrado');
                        this.$emit('exito');
                    }else{
                        var errores = JSON.stringify(data.data.createCiudad.errors);
                        var obj = JSON.parse( errores );
                        var vals = '';
                        obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                        vue.$refs.alertar.invalido( vals );
                    }
                    vue.activo = true;
                }).catch((error) => {
                    window.console.error('ERROR: ',JSON.stringify(error));
                    try{
                        let msg = error.graphQLErrors[0].message['message'];
                        vue.$refs.alertar.invalido( 'SERVER: '+msg );
                    }catch(e){
                        window.console.log( e )
                        vue.$refs.alertar.invalido();
                    }
                    
                })
            },
            actualizar(){
                this.msg = null;
                var sql = gql`mutation{ updateCiudad(input:{id:${this.edit.id},nombre:"${this.ciudad.nombre}",iddepartamento:${this.ciudad.iddepartamento.id}}){ok,errors{message}} }`;
                var vue = this;
                vue.$refs.alertar.cargando('Actualizando...');
                vue.activo = false;
                window.console.log( sql )
                this.$apollo.mutate({mutation: sql})
                .then((data) => {
                  if( data.data.updateCiudad){
                    vue.$refs.alertar.success('Actualizado');
                    this.$emit('exito');
                  }else{
                    var errores = JSON.stringify(data.data.updateCiudad.errors);
                    var obj = JSON.parse(errores);
                    var vals = "Error Desconocido";
                    if( obj != null ) obj.forEach(function(k) { vals += Object.values(k) + "-\n\t"; });
                    vue.msg = vals;
                  }
                    vue.activo = true;
                 
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                    vue.activo = true;
                })
            },
        },
        mounted(){
          var vue = this;
          window.$('#modal-nciudad').on('shown.bs.modal',function(){ 
                vue.llenar();
            });
          window.$('#modal-nciudad').on('hidden.bs.modal',function(){ 
              vue.ciudad.nombre=null;
              vue.ciudad.iddepartamento=null;
              vue.estado=true;
              vue.$refs.alertar.reset();
          });
        }
    
    }
</script>